import React from "react";
import OrdersReducer from "./OrdersReducer";
import OrdersContext from "./OrdersContext";
import MethodGet, { MethodPost } from "../../config/Service";
import {
  APROVE_ORDER,
  CANCELAR_VENTAS,
  GET_ALL_ORDER,
  GET_ALL_ORDERS_APROVE,
  GET_ALL_ORDERS_COMPLETED,
  GET_ALL_ORDERS_PENDING,
  GET_ALL_ORDERS_PREPARING,
  GET_ALL_ORDERS_PREPARING_SELLER,
  GET_ALL_ORDERS_SHIPPING,
  GET_ALL_ORDERS_SHIPPING_SELLER,
  GET_ALL_ORDERS_VALIDATING_PAYMENT,
  GET_SALES_PREPARING_FOR_SELLER,
  GET_SALES_SHIPPING_FOR_SELLER,
  MAKE_AS_READY,
  SELLER_GET_ORDERS_PREPARING,
  TAKE_ORDER,
  VALIDANDO_PAGO_PEDIDO,
} from "../../types";
import { useReducer } from "react";
import Swal from "sweetalert2";
import fileDownload from "js-file-download";
import clienteAxios from "../../config/Axios";
const OrdersState = ({ children }) => {
  const initialState = {
    orders: [],
    ordersCompleted: [],
    ErrorsApi: [],
    success: false,
  };
  const [state, dispatch] = useReducer(OrdersReducer, initialState);
  const GetAllOrders = () => {
    let url = `/distribucion/Sales`;
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_ORDER,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetAllOrdersCompleted = () => {
    let url = `/distribucion/finalizedsales`;
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_ORDERS_COMPLETED,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const PdfOrder = (order) => {
    Swal.fire({
      title: "¿Descargar PDF de la orden ?",
      text: "Se descargará el pdf de la orden",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, descargar",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.value) {
        let timerInterval;
        Swal.fire({
          title: "Generando",
          html: "El PDF se esta generando!",

          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        });
        let url = `/ticket/${order}`;
        clienteAxios
          .get(url, { responseType: "blob" })
          .then((res) => {
            fileDownload(res.data, `Orden_#${order}.pdf`);
            // const safeFileName = encodeURIComponent(`Orden_${order.id}.pdf`);
            // fileDownload(res.data, safeFileName);
            Swal.fire({
              title: "Descargado",
              text: "El PDF de la orden se ha descargado correctamente",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: "Error",
              icon: "error",
              text: "Se ha producido un error al descargar el PDF",
            });
          });
      }
    });
  };

  const SalesOfDay = () => {
    Swal.fire({
      title: "¿Descargar Corte de caja?",
      text: "Se descargará el corte de caja",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, descargar",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.value) {
        let url = `/distribucion/cashreport/`;
        clienteAxios
          .get(url, { responseType: "blob" })
          .then((res) => {
            let timerInterval;
            Swal.fire({
              title: "Generando",
              html: "El PDF se esta generando!",
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();
              },
              willClose: () => {
                clearInterval(timerInterval);
              },
            }).then((result) => {
              fileDownload(res.data, `corte_de_caja.pdf`);
              const safeFileName = encodeURIComponent(`corte_de_caja.pdf`);
              fileDownload(res.data, safeFileName);
              Swal.fire({
                title: "Descargado",
                text: "El PDF del corte de caja se ha descargado correctamente",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
              });
            });
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: "Error",
              icon: "error",
              text: "Se ha producido un error al descargar el PDF",
            });
          });
      }
    });
  };

  const CreateOrder = (data) => {
    // console.log(data, "la data en el state");
  };

  const MakeAsReady = (data) => {
    let url = `/distribucion/Sms/${data.id}`;
    MethodPost(url, data)
      .then((res) => {
        dispatch({
          type: MAKE_AS_READY,
          payload: data.id,
        });
        let timerInterval;
        Swal.fire({
          title: "Enviando",
          html: "Marcando el pedido como enviado!",
          timer: 2000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result) => {
          // fileDownload(res.data, `Orden_${order.id}.pdf`);
          // const safeFileName = encodeURIComponent(`Orden_${order.id}.pdf`);
          // fileDownload(res.data, safeFileName);
          Swal.fire({
            title: "Notificado",
            text: "Se ha enviado un sms al cliente para notificarle que su pedido, ya sido enviado",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
        });
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "Error",
          icon: "error",
          text: "Se ha producido un error al enviar el SMS",
        });
      });
  };
  const GetAllOrdersPending = () => {
    let url = "/distribucion/SalesPendindVerification";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_ORDERS_PENDING,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetAllOrdersAprove = () => {
    let url = "/distribucion/SalesApprove";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_ORDERS_APROVE,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetAllordersPreparing = () => {
    let url = "/distribucion/SalesPreparing";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_ORDERS_PREPARING,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetAllOrdersPreparingSeller = (seller) => {
    let url = `/distribucion/SalesPreparing/${seller}`;
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_SALES_PREPARING_FOR_SELLER,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetAllOrdersValidatingPayment = () => {
    let url = "/distribucion/validandoPagoAdmin";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_ORDERS_VALIDATING_PAYMENT,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetAllOrdersShipping = () => {
    let url = "/distribucion/SalesShipp";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_ORDERS_SHIPPING,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetAllOrdersShippingSeller = (seller) => {
    let url = `/distribucion/SalesShipp/${seller}`;
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_SALES_SHIPPING_FOR_SELLER,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const AproveOrder = (id) => {
    Swal.fire({
      title: "Pago Verificado",
      text: "Se marcara como pago verificado",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, continuar",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.value) {
        let url = `/distribucion/aproveOrder/${id}`;
        let timerInterval;
        Swal.fire({
          title: "Validando",
          html: "El pago se esta validando!",
          timer: 2000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        });
        MethodPost(url)
          .then((res) => {
            dispatch({
              type: APROVE_ORDER,
              payload: id,
            });
            Swal.fire({
              title: "Aprobado",
              text: "El pago se ha verificado existosamente!",
              icon: "success",
              timer: 2500,
              showConfirmButton: false,
            });
          })
          .catch((error) => console.log(error));
      }
    });
  };
  const TakeOrder = (id, seller) => {
    console.log(seller, "el seller name");
    Swal.fire({
      title: "Preparar pedido",
      text: "Se marcara como preparando pedido",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, continuar",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.value) {
        let url = `/distribucion/preparingOrder/${id}/${seller}`;
        MethodPost(url)
          .then((res) => {
            dispatch({
              type: TAKE_ORDER,
              payload: id,
            });
          })
          .catch((error) => console.log(error));
      }
    });
  };

  const CancelOrders = () => {
    let url = "/distribucion/cancelar_ventas";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: CANCELAR_VENTAS,
          payload: res.data,
        });
        console.log("se han cancelado las ventas sin pagos");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const OrderInvoice = (id) => {
    Swal.fire({
      title: "Facturar compra",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, Facturar",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Facturar compra",
          html: `
              <p>Seleccione el método de pago:</p>
              <select id="paymentMethod" class="swal2-input">
                <option value="01">Deposito en Efectivo</option>
                <option value="03">Transferencia Electronica de Fondos</option>
              </select>
            `,
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Facturar",
          cancelButtonText: "Cancelar",
          preConfirm: () => {
            const paymentMethod =
              document.getElementById("paymentMethod").value;
            if (!paymentMethod) {
              Swal.showValidationMessage(
                "Por favor, selecciona un método de pago"
              );
            }
            return paymentMethod;
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const paymentMethod = result.value;
            let url = `/distribucion/invoice-distributor/${id}`;
            MethodPost(url, { payment_form: paymentMethod })
              .then(() => {
                Swal.fire({
                  title: "¡Facturado!",
                  text: "La venta se ha facturado correctamente.",
                  icon: "success",
                });
                // dispatch({
                //   type: INVOICE_ORDER,
                //   payload: id,
                // });
              })
              .catch((error) => {
                Swal.fire({
                  title: "Error",
                  text:
                    error.response?.data?.message || "Ha ocurrido un error.",
                  icon: "error",
                });
              });
          }
        });
      }
    });
  };

  const GetPdfInvoice = (id) => {
    Swal.fire({
      title: "Descargar",
      text: "Se descargará la factura",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, descargar",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.value) {
        let url = `/distribucion/downloadInvoicePDF/${id}`;
        clienteAxios
          .get(url, { responseType: "blob" })
          .then((response) => {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Factura_${id}.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  return (
    <OrdersContext.Provider
      value={{
        orders: state.orders,
        ErrorsApi: state.ErrorsApi,
        success: state.success,
        ordersCompleted: state.ordersCompleted,
        GetAllOrders,
        PdfOrder,
        GetAllordersPreparing,
        GetAllOrdersShipping,
        CreateOrder,
        MakeAsReady,
        SalesOfDay,
        GetAllOrdersCompleted,
        GetAllOrdersPending,
        GetAllOrdersAprove,
        AproveOrder,
        TakeOrder,
        GetAllOrdersValidatingPayment,
        GetAllOrdersPreparingSeller,
        GetAllOrdersShippingSeller,
        CancelOrders,
        OrderInvoice,
        GetPdfInvoice,
      }}
    >
      {children}
    </OrdersContext.Provider>
  );
};

export default OrdersState;
